function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5C7284",
  fillRule: "nonzero",
  d: "M15,1.5 C22.4558441,1.5 28.5,7.54415588 28.5,15 C28.5,22.4558441 22.4558441,28.5 15,28.5 C7.54415588,28.5 1.5,22.4558441 1.5,15 C1.48503563,11.4150108 2.90254707,7.97253156 5.43753931,5.43753931 C7.97253156,2.90254707 11.4150108,1.48503563 15,1.5 Z M15,-1.13686838e-13 C6.71572875,-1.13686838e-13 -1.42108547e-14,6.71572875 -1.42108547e-14,15 C-1.42108547e-14,23.2842712 6.71572875,30 15,30 C23.2842712,30 30,23.2842712 30,15 C29.9758351,6.72575887 23.2742411,0.0241649367 15,-1.13686838e-13 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C7284",
  d: "M21.151,12.126 L20.619,22.211 C20.599,22.582 20.293,22.872 19.922,22.872 L11.079,22.872 C10.708,22.872 10.402,22.582 10.382,22.211 L9.85,12.126 C9.83,11.741 10.125,11.413 10.51,11.392 C10.896,11.374 11.223,11.668 11.243,12.052 L11.741,21.477 L19.26,21.477 L19.758,12.052 C19.778,11.668 20.109,11.375 20.491,11.392 C20.876,11.413 21.171,11.741 21.151,12.126 Z M23,9.791 C23,10.176 22.688,10.489 22.303,10.489 L8.698,10.489 C8.313,10.489 8,10.176 8,9.791 C8,9.406 8.313,9.093 8.698,9.093 L12.535,9.093 L12.535,7.523 C12.535,7.186 12.76,7 13.097,7 L17.903,7 C18.241,7 18.466,7.186 18.466,7.523 L18.466,9.093 L22.303,9.093 C22.688,9.093 23,9.406 23,9.791 Z M13.756,9.093 L17.244,9.093 L17.244,8.221 L13.756,8.221 L13.756,9.093 Z M14.049,20.43 L14.063,20.43 C14.401,20.43 14.667,20.106 14.659,19.769 L14.482,12.228 C14.474,11.891 14.198,11.616 13.857,11.623 C13.52,11.631 13.253,11.906 13.261,12.243 L13.439,19.8 C13.447,20.132 13.718,20.43 14.049,20.43 Z M16.925,20.43 C17.256,20.43 17.528,20.15 17.536,19.818 L17.713,12.287 C17.721,11.95 17.454,11.666 17.117,11.658 C16.775,11.653 16.5,11.915 16.492,12.252 L16.315,19.79 C16.307,20.127 16.574,20.43 16.911,20.43 L16.925,20.43 Z"
}));

function SvgIconDiscardCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscardCircle);
export default __webpack_public_path__ + "static/media/icon_discard_circle.4014cfac.svg";
export { ForwardRef as ReactComponent };